// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { User } from './User';
import { SettingItem } from './SettingItem';
/**
 * 用户设置 实体类
 * 用户设置
 */
export class UserSetting extends BaseEntity {
  /** 设置值 : 设置项的值，多选时为选项值之和 */
  private _itemValue: string;

  /** 设置：设置值 */
  public get itemValue() {
    return this._itemValue;
  }

  /** 获取：设置值 */
  public set itemValue(value: string) {
    this._itemValue = value;
  }

  /** 应用ID : 应用ID，定义应用的设置 */
  private _aPPId: string;

  /** 设置：应用ID */
  public get aPPId() {
    return this._aPPId;
  }

  /** 获取：应用ID */
  public set aPPId(value: string) {
    this._aPPId = value;
  }

  /** 产品ID : 产品ID，定义产品的设置 */
  private _productId: string;

  /** 设置：产品ID */
  public get productId() {
    return this._productId;
  }

  /** 获取：产品ID */
  public set productId(value: string) {
    this._productId = value;
  }

  /** 用户 的ID */
  private _user_ID: string;

  /** 获取：用户 的ID */
  public get user_ID() {
    return this._user_ID;
  }

  /** 设置：用户 的ID */
  public set user_ID(value: string) {
    this._user_ID = value;
  }

  /** 用户  */
  private _user: User;

  /** 获取：用户  */
  public get user() {
    return this._user;
  }

  /** 设置：用户  */
  public set user(value: User) {
    this._user = value;
    if (value !== null) {
      this.user_ID = value.id;
    } else {
      this.user_ID = '';
    }
  }

  /** 设置项 的ID */
  private _settingItem_ID: string;

  /** 获取：设置项 的ID */
  public get settingItem_ID() {
    return this._settingItem_ID;
  }

  /** 设置：设置项 的ID */
  public set settingItem_ID(value: string) {
    this._settingItem_ID = value;
  }

  /** 设置项  */
  private _settingItem: SettingItem;

  /** 获取：设置项  */
  public get settingItem() {
    return this._settingItem;
  }

  /** 设置：设置项  */
  public set settingItem(value: SettingItem) {
    this._settingItem = value;
    if (value !== null) {
      this.settingItem_ID = value.id;
    } else {
      this.settingItem_ID = '';
    }
  }

  constructor() {
    super();
    this._itemValue = '';
    this._aPPId = '';
    this._productId = '';
    this._user_ID = '';
    this._user = null;
    this._settingItem_ID = '';
    this._settingItem = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: UserSetting, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.itemValue = element.itemValue;
      this.aPPId = element.aPPId;
      this.productId = element.productId;
      this.user_ID = element.user_ID;
      if (hasReference && element.user !== null) {
        this.user = element.user;
      }
      this.settingItem_ID = element.settingItem_ID;
      if (hasReference && element.settingItem !== null) {
        this.settingItem = element.settingItem;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.itemValue = json.ItemValue;
    this.aPPId = json.APPId;
    this.productId = json.ProductId;
    this.user_ID = json.User_ID;
    // if (json.User !== null) {
    //   this.user = User.Create(json.User);
    // }
    this.settingItem_ID = json.SettingItem_ID;
    // if (json.SettingItem !== null) {
    //   this.settingItem = SettingItem.Create(json.SettingItem);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ItemValue = this.itemValue;
    json.APPId = this.aPPId;
    json.ProductId = this.productId;
    json.User_ID = this.user_ID;
    json.SettingItem_ID = this.settingItem_ID;
  }

  static Create(json: any): UserSetting {
    const userSetting = new UserSetting();
    userSetting.Deserialize(json);
    userSetting.json = json;
    return userSetting;
  }
}
